import { render, staticRenderFns } from "./phone.vue?vue&type=template&id=13f396bf&scoped=true"
import script from "./phone.vue?vue&type=script&lang=js"
export * from "./phone.vue?vue&type=script&lang=js"
import style0 from "./phone.vue?vue&type=style&index=0&id=13f396bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f396bf",
  null
  
)

export default component.exports